export type OrientationMode = 'map' | 'fixed' | 'readable' | 'screen';

/** Ce que le réglage écrit sur un texte ou une image (`rotation`, `rotateWithMap`, `keepReadable`). */
export type OrientationValues = { rotation?: number; rotateWithMap?: boolean; keepReadable?: boolean; };

export const ORIENTATION_LABELS: Record<OrientationMode, string> = {
	map: 'suit la carte',
	fixed: 'angle fixe',
	readable: 'lisible',
	screen: 'toujours droit',
};

export const orientationModeOf = (values: OrientationValues | undefined): OrientationMode => {
	if (values?.rotateWithMap) return 'screen';
	if (values?.keepReadable) return 'readable';

	return values?.rotation === undefined ? 'map' : 'fixed';
};
